const AmpGeo = () => {
  return (
    <>
      <amp-geo layout='nodisplay'>
        <script type="application/json" dangerouslySetInnerHTML={{ __html: `
          {
            "ISOCountryGroups": {
              "eea": [
                "at",
                "be",
                "bg",
                "ch",
                "cy",
                "cz",
                "de",
                "dk",
                "ee",
                "es",
                "fi",
                "fr",
                "gb",
                "gr",
                "hr",
                "hu",
                "ie",
                "is",
                "it",
                "li",
                "lt",
                "lu",
                "lv",
                "mt",
                "nl",
                "no",
                "pl",
                "pt",
                "ro",
                "se",
                "si",
                "sk"
              ]
            }
          }
        `}} />
      </amp-geo>
      <amp-consent layout="nodisplay" id="consent-element">
        <script type="application/json" dangerouslySetInnerHTML={{ __html: `
          {
            "consents": {
              "cbsiampconsent": {
                "promptIfUnknownForGeoGroup": "eea",
                "promptUI": "consentDialog"
              }
            },
            "postPromptUI": "post-consent-ui"
          }
        `}} />
        <div className="popupOverlay" id="consentDialog">
          <div className="consentPopup">
            <p>We and our partners use cookies to understand how you use our site, improve your experience and serve you personalized content and advertising. Read about how we use cookies in our
              <a href="https://www.cbsinteractive.com/legal/cbsi/privacy-policy/cookies-and-beacons" target="_blank" rel="noopener noreferrer"> cookie policy</a> and how you can control them by clicking
              <a href="https://www.cbsinteractive.com/legal/cbsi/privacy-policy/manage-settings-master-list" target="_blank" rel="noopener noreferrer"> Manage Settings</a>. By continuing to use this site, you accept these cookies.
            </p>
            <button type="button" className="consent-accept" on="tap:consent-element.accept">Accept</button>
            <button type="button" className="consent-reject" on="tap:consent-element.reject">Reject</button>
          </div>
        </div>
        <div id="post-consent-ui">
          <button type="button" on="tap:consent-element.prompt()" className="consent-manage">Update Consent</button>
        </div>
      </amp-consent>
    </>
  );
};

export default AmpGeo;
